import { useContext, createContext } from 'react';

export const CourseContext = createContext(null);

export function useCourseContext() {
  return useContext(CourseContext);
}
